import { IconProps } from '@components/Icons/index';

const defaultSize = 13;
const aspectRatio = 13 / 9;

export const ExpandIcon = ({ size, className }: IconProps) => {
  return (
    <svg
      className={className}
      width={size ?? defaultSize}
      height={(size ?? defaultSize) / aspectRatio}
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.14383 8.22747L0.877295 2.96094C0.513286 2.59693 0.513286 2.00832 0.877295 1.64818L1.75247 0.773007C2.11648 0.408997 2.70509 0.408997 3.06523 0.773007L6.79827 4.50605L10.5313 0.773008C10.8953 0.408997 11.4839 0.408997 11.8441 0.773008L12.727 1.64431C13.091 2.00832 13.091 2.59693 12.727 2.95707L7.46046 8.2236C7.09645 8.59148 6.50784 8.59148 6.14383 8.22747Z"
        fill="white"
      />
    </svg>
  );
};
